"use client";
import React from "react";
import { Box, Flex, Text, Portal, Menu, Icon } from "@chakra-ui/react";
import { Link } from "react-router-dom";
import { useNav } from "../reusables/Navbar/navConfig";

import { FcList } from "react-icons/fc";

export default function ServiceMenu() {
  const { main, more } = useNav(8);

  return (
    <Box
      bg="brand.20"
      w="full"
      py={4}
      shadow="sm"
      borderBottom="1px solid"
      borderColor="gray.100"
      // display={{ base: "none", md: "block" }} // only web
    >
      <Flex
        mx={12}
        gap={4}
        justify="space-evenly"
        overflowX="auto"
        flexWrap="nowrap"
        align="center"
        css={{
          scrollbarWidth: "none",
          "&::-webkit-scrollbar": { display: "none" },
        }}
      >
        {/* Main categories */}
        {main.map((cat) => (
          <Link key={cat.id} to={cat.path || ""}>
            <Flex
              direction="column"
              align="center"
              cursor="pointer"
              flexShrink={0}
              transition="all 0.2s ease"
              _hover={{ transform: "translateY(-2px)" }}
            >
              {cat.icon && (
                <Icon
                  as={cat.icon}
                  boxSize={6}
                  className="service-icon"
                  color={cat.themeColor ? `${cat.themeColor}.500` : undefined}
                />
              )}
              <Text
                fontSize={["2xs", "xs", "sm"]}
                fontWeight="medium"
                mt={2}
                textAlign="center"
                color="gray.700"
              >
                {cat.label}
              </Text>
            </Flex>
          </Link>
        ))}

        {/* Collapsible More */}
        {more.length > 0 && (
          <Menu.Root>
            <Menu.Trigger asChild>
              <Flex
                direction="column"
                align="center"
                cursor="pointer"
                flexShrink={0}
                transition="all 0.2s ease"
                _hover={{ transform: "translateY(-2px)" }}
              >
                <FcList size={32} />
                <Text fontSize="xs" fontWeight="medium" mt={2} color="gray.700">
                  More
                </Text>
              </Flex>
            </Menu.Trigger>

            <Portal>
              <Menu.Positioner>
                <Menu.Content
                  bg="white"
                  shadow="lg"
                  rounded="md"
                  p={2}
                  minW="220px"
                  maxH="300px"
                  overflowY="auto"
                  css={{
                    "&::-webkit-scrollbar": {
                      width: "6px",
                    },
                    "&::-webkit-scrollbar-thumb": {
                      background: "#cbd5e0", // gray.300
                      borderRadius: "8px",
                    },
                  }}
                >
                  {more.map((cat, i) => (
                    <Link key={cat.id} to={cat.path || "#"}>
                      <Flex
                        align="center"
                        px={3}
                        py={2}
                        gap={3}
                        _hover={{ bg: "gray.100" }}
                        transition="background 0.2s ease"
                        borderBottom={
                          i !== more.length - 1 ? "1px solid" : "none"
                        }
                        borderColor="gray.200"
                      >
                        {cat.icon && (
                          <Icon
                            as={cat.icon}
                            boxSize={5}
                            color={
                              cat.themeColor
                                ? `${cat.themeColor}.500`
                                : undefined
                            }
                          />
                        )}
                        <Text fontSize="sm" fontWeight="medium">
                          {cat.label}
                        </Text>
                      </Flex>
                    </Link>
                  ))}
                </Menu.Content>
              </Menu.Positioner>
            </Portal>
          </Menu.Root>
        )}
      </Flex>
    </Box>
  );
}

// src/data/services.ts
// export type ServiceItem = {
//   id: number;
//   name: string;
//   icon: string;
//   href: string;
//   category: "main" | "more";
// };

// export const services: ServiceItem[] = [
//   {
//     id: 1,
//     name: "Prepaid/Postpaid",
//     icon: "https://assetscdn1.paytm.com/images/catalog/view_item/105637/1686289280267.png",
//     href: "/recharge",
//     category: "main",
//   },
//   {
//     id: 2,
//     name: "Electricity",
//     icon: "https://assetscdn1.paytm.com/images/catalog/view_item/136550/1554946473611.png",
//     href: "/electricity-bill-payment",
//     category: "main",
//   },
//   {
//     id: 3,
//     name: "DTH",
//     icon: "https://assetscdn1.paytm.com/images/catalog/view_item/105638/1554946480031.png",
//     href: "/dth",
//     category: "main",
//   },
//   {
//     id: 4,
//     name: "Metro",
//     icon: "https://assetscdn1.paytm.com/images/catalog/view_item/105651/1554946474398.png",
//     href: "/metro-card-recharge",
//     category: "main",
//   },
//   {
//     id: 5,
//     name: "Broadband/Landline",
//     icon: "https://assetscdn1.paytm.com/images/catalog/view_item/105643/1602741621166.png",
//     href: "/landline-bill-payment",
//     category: "main",
//   },
//   {
//     id: 6,
//     name: "Education",
//     icon: "https://assetscdn1.paytm.com/images/catalog/view_item/105648/1602741754777.png",
//     href: "/education",
//     category: "main",
//   },
//   {
//     id: 7,
//     name: "Pay Loan",
//     icon: "https://assetscdn1.paytm.com/images/catalog/view_item/659691/1602741233182.png",
//     href: "/loan-emi-payment",
//     category: "main",
//   },
//   {
//     id: 9,
//     name: "Book a Cylinder",
//     icon: "https://assetscdn1.paytm.com/images/catalog/view_item/732357/1626446407655.png",
//     href: "/cylinder-gas-recharge",
//     category: "main",
//   },

//   // more
//   {
//     id: 11,
//     name: "Google Play Recharge",
//     icon: "https://assetscdn1.paytm.com/images/catalog/view_item/105655/1602742093598.png",
//     href: "/google-play-gift-card-recharge",
//     category: "more",
//   },
//   {
//     id: 12,
//     name: "Piped Gas Bill",
//     icon: "https://assetscdn1.paytm.com/images/catalog/view_item/302674/1554946480045.png",
//     href: "/gas-bill-payment",
//     category: "more",
//   },
//   {
//     id: 13,
//     name: "Water",
//     icon: "https://assetscdn1.paytm.com/images/catalog/view_item/105660/1554946474118.png",
//     href: "/water-bill-payment",
//     category: "more",
//   },
//   {
//     id: 14,
//     name: "Challan",
//     icon: "https://assetscdn1.paytm.com/images/catalog/view_item/105644/1554946475392.png",
//     href: "/challan-bill-payment",
//     category: "more",
//   },
//   {
//     id: 15,
//     name: "Municipal Payments",
//     icon: "https://assetscdn1.paytm.com/images/catalog/view_item/112887/1554946481613.png",
//     href: "/municipal-payments",
//     category: "more",
//   },
//   {
//     id: 16,
//     name: "Cable TV",
//     icon: "https://assetscdn1.paytm.com/images/catalog/view_item/659733/1602752683626.png",
//     href: "/cabletv",
//     category: "more",
//   },
//   {
//     id: 17,
//     name: "Toll Tag",
//     icon: "https://assetscdn1.paytm.com/images/catalog/view_item/105658/1554946478360.png",
//     href: "/toll-tag-recharge",
//     category: "more",
//   },
// ];

// export default function ServiceMenu() {
//   const mainServices = services.filter((s) => s.category === "main");
//   const moreServices = services.filter((s) => s.category === "more");

//   return (
//     <Box bg={"blue.300"} className="service-wrapper" w="full" py={6}>
//       <Flex
//         mx={12}
//         wrap="wrap"
//         gap={2}
//         justify="space-evenly"
//         overflowX="auto"
//         flexWrap="nowrap"
//       >
//         {mainServices.map((service) => (
//           <Link key={service.id} to={service.href}>
//             <Flex
//               className="service-item"
//               direction="column"
//               align="center"
//               //   _hover={{ transform: "scale(1.05)" }}
//               transition="all 0.2s ease"
//             >
//               <Image
//                 src={service.icon}
//                 alt={service.name}
//                 boxSize="30px"
//                 w="30px"
//                 h="20px"
//                 objectFit="contain"
//               />
//               <Text
//                 fontSize={["2xs", "xs", "sm"]}
//                 fontWeight="medium"
//                 mt={2}
//                 textAlign="center"
//               >
//                 {service.name}
//               </Text>
//             </Flex>
//           </Link>
//         ))}

//         {/* Collapsible More */}
//         <Menu.Root>
//           <Menu.Trigger asChild>
//             <Flex
//               direction="column"
//               align="center"
//               cursor="pointer"
//               //   _hover={{ transform: "scale(1.05)" }}
//             >
//               <Box
//                 bg="gray.100"
//                 w="30px"
//                 h="20px"
//                 rounded="md"
//                 display="flex"
//                 alignItems="center"
//                 justifyContent="center"
//               >
//                 ⋯
//               </Box>
//               <Text fontSize="xs" fontWeight="medium" mt={2}>
//                 More
//               </Text>
//             </Flex>
//           </Menu.Trigger>
//           <Portal>
//             <Menu.Positioner>
//               <Menu.Content
//                 bg="white"
//                 shadow="lg"
//                 rounded="md"
//                 p={2}
//                 _focus={{ boxShadow: "none", outline: "none" }} // default border/focus remove
//               >
//                 <Box>
//                   {moreServices.map((item, i) => (
//                     <Link key={item.id} to={item.href}>
//                       <Flex
//                         direction="row"
//                         align="center"
//                         px={3}
//                         py={2}
//                         gap={3}
//                         _hover={{ bg: "gray.100" }} //  halka hover effect
//                         transition="background 0.2s ease"
//                         borderBottom={
//                           i !== moreServices.length - 1 ? "1px solid" : "none"
//                         } //  last item ko chodke sabke niche line
//                         borderColor="gray.200"
//                       >
//                         <Image
//                           src={item.icon}
//                           alt={item.name}
//                           w="30px"
//                           h="20px"
//                           objectFit="contain"
//                         />
//                         <Text fontSize="sm" fontWeight="medium">
//                           {item.name}
//                         </Text>
//                       </Flex>
//                     </Link>
//                   ))}
//                 </Box>
//               </Menu.Content>
//             </Menu.Positioner>
//           </Portal>
//         </Menu.Root>
//       </Flex>
//     </Box>
//   );
// }
